import { v4 } from 'uuid';

export default function getEmptyEntity(color?: string) {
  return {
    id: v4(),
    title: '',
    isNew: true,
    color: color || null,
    avatarId: '',
  };
}
